<div [class.content-area]="standalone">
  <ng-container *ngIf="standalone; else embedded">
    <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Offene Transportscheine</h2>
    <p class="opener" cds-text="section">Diese Transporte müssen bearbeitet werden oder warten auf Abholung...</p><br>
  </ng-container>
  <ng-template #embedded><h3>Transportscheine</h3></ng-template>

  <clr-datagrid *ngIf="!!transport" [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'transport_id'">Transportschein</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">zu Auftrag</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Kunde/Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'delivery_date'" [clrDgSortOrder]="descSort">Datum</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Transport Document!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let delivery of transport" [routerLink]="['/transport/details', delivery.project_id, jobId, delivery.transport_id, delivery.order_id]">
      <clr-dg-cell>{{ delivery.project_id }}.0005.{{ delivery.transport_id }}</clr-dg-cell>
      <clr-dg-cell>{{ delivery.project_id }}.0002.{{ delivery.order_id}}</clr-dg-cell>
      <clr-dg-cell><b>{{ delivery.company_name }}</b><br />{{ delivery.name_project }}</clr-dg-cell>
      <clr-dg-cell>{{ delivery.delivery_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell [className]="findButtonClass(delivery.status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <div class="alert-icon-wrapper">
              <cds-icon class="alert-icon" [attr.shape]="statusOf(delivery.status).icon"></cds-icon>
            </div>
            <span class="alert-text">{{ statusOf(delivery.status).display }}</span>
          </div>
        </div>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Transportscheine pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von  {{ transport.length }} Transportschein(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
